import { render } from "./GrantUsageModal.vue?vue&type=template&id=eb6986fa&scoped=true"
import script from "./GrantUsageModal.vue?vue&type=script&lang=js"
export * from "./GrantUsageModal.vue?vue&type=script&lang=js"

import "./GrantUsageModal.vue?vue&type=style&index=0&id=eb6986fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6986fa"]])

export default __exports__